import { fetchFactory } from '../../../utils/fetchFactory'

export const getGlobalData = async () => fetchFactory('/api/monitoring/', {
    method: 'GET'
})